import { Component } from '@angular/core';
import { LocationFormFieldComponent } from './location-form-field.component'; // Path to the original component
import { LocationObject } from '../../../../swagger-api';
import { getStringRepresentationOfLocation } from './location-form-field.helper';
import { ValidatorFn, Validators } from '@angular/forms';
import { LocationInputAutocompleteService } from './geocoding/location-input-autocomplete.service';

@Component({
  selector: 'app-string-location-form-field',
  templateUrl: './location-form-field.component.html',
  styleUrls: ['./location-form-field.component.scss'],
  providers: [LocationInputAutocompleteService],
})
export class StringLocationFormFieldComponent extends LocationFormFieldComponent {
  protected override setupValidators() {
    const validators: ValidatorFn[] = [
      Validators.minLength(this.fieldAttribute.backendAttribute.min_length),
      Validators.maxLength(this.fieldAttribute.backendAttribute.max_length),
    ];

    if (this.fieldAttribute.backendAttribute.required) {
      validators.push(Validators.required);
    }

    this.control.setValidators(Validators.compose(validators));
  }

  protected override setupNativeElementValue() {
    this.searchElementRef.nativeElement.value = (this.control.value as string) ?? '';
  }

  protected override updateValue() {
    if (!this.searchElementRef.nativeElement.value) {
      this.control.setValue('');
      this.control.markAsDirty();
      return;
    }

    this.setupNativeElementValue();
  }

  protected override updateControlValue(location: LocationObject) {
    this.control.setValue(getStringRepresentationOfLocation(location));
    this.control.markAsDirty();
  }

  protected override onNullControlValue() {
    super.onNullControlValue();

    this.control.setValue('');
    this.control.markAsDirty();
  }
}
